import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';

type CompanySettings = {
  max_concurrent_conversations: number
}

export function useCompanySettings() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['company-settings'],
    queryFn: async () => {
      return apiClient<CompanySettings>('/company-settings')
    },
  })
}

export function useUpdateCompanySettings() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (settings: CompanySettings) => {
      return apiClient<CompanySettings>('/company-settings', {
        method: 'PATCH',
        body: JSON.stringify(settings),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-settings'] })
    },
  })
}

// --- Simulation settings ---

export type SimulationSettingsData = {
  customer_model: string
  evaluator_model: string
  qa_import_model: string
  qa_import_prompts: {
    generate_evaluation: string
    test_agent: string
    evaluation_simple: string
  }
  defaults: {
    customer_model: string
    evaluator_model: string
    qa_import_model: string
    qa_import_prompts: {
      generate_evaluation: string
      test_agent: string
      evaluation_simple: string
    }
  }
}

export function useSimulationSettings() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['simulation-settings'],
    queryFn: async () => {
      return apiClient<SimulationSettingsData>('/simulation-settings')
    },
  })
}

export function useUpdateSimulationSettings() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (settings: Partial<Omit<SimulationSettingsData, 'defaults'>>) => {
      return apiClient<SimulationSettingsData>('/simulation-settings', {
        method: 'PATCH',
        body: JSON.stringify(settings),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['simulation-settings'] })
    },
  })
}